module.exports = "<div class=\"container\">\n  <h4 class=\"sobre-titulo\">Templates</h4>\n  <hr>\n  <br>\n  <a href=\"assets/PE_MetodoParaPesq.docx\" download>\n    <img src=\"assets/docxico.ico\">\n    Template para PLANO DE CAPACITAÇÃO DO CURSO DE EXTENSÃO\n  </a>\n  <br>\n  <br>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/templates.component.html
// module id = ./src/app/templates/templates.component.html
// module chunks = main